"use client";

import { Share2, UserPlus, Wallet, ArrowLeft } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { faNum } from "@/lib/format";
import { pushView } from "@/stores/useAppStore";

type Step = {
  icon: LucideIcon;
  title: string;
  desc: string;
};

const STEPS: Step[] = [
  {
    icon: Share2,
    title: "کد معرف خود را بگیر",
    desc: "پس از ثبت‌نام، یک کد معرف اختصاصی در پنل کاربری دریافت می‌کنید.",
  },
  {
    icon: UserPlus,
    title: "دوستانت را دعوت کن",
    desc: "کد معرف را با دوستانت به اشتراک بگذار تا با آن ثبت‌نام کنند.",
  },
  {
    icon: Wallet,
    title: "کمیسیون بگیر",
    desc: "به‌ازای هر خرید زیرمجموعه، درصدی به‌عنوان کمیسیون به حساب شما اضافه می‌شود.",
  },
];

export function HowItWorks() {
  return (
    <section
      id="commission"
      aria-labelledby="commission-heading"
      className="py-20 md:py-24"
    >
      <div className="mx-auto w-full max-w-7xl px-4">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
            سیستم کمیسیون
          </span>
          <h2
            id="commission-heading"
            className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl"
          >
            با کمیسیون، درآمد بساز
          </h2>
          <p className="mt-3 text-muted-foreground">
            کافیست دوستانت را به پلتفرم دعوت کنی؛ هر خرید آن‌ها، درآمد برای تو
            می‌سازد.
          </p>
        </div>

        <ol className="relative mt-14 grid grid-cols-1 gap-8 sm:grid-cols-3">
          {/* Dashed connector line (desktop) */}
          <div
            aria-hidden
            className="absolute top-7 right-0 left-0 hidden h-px border-t border-dashed border-primary/30 sm:block"
          />

          {STEPS.map((step, idx) => (
            <li
              key={step.title}
              className="relative flex flex-col items-center gap-3 text-center"
            >
              <div className="relative flex items-center gap-3">
                <span className="flex size-14 items-center justify-center rounded-2xl border border-primary/30 bg-card text-primary shadow-sm">
                  <step.icon className="size-6" />
                </span>
                <span className="absolute -right-3 -top-3 flex size-7 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground shadow">
                  {faNum(idx + 1)}
                </span>
              </div>
              <h3 className="text-base font-semibold">{step.title}</h3>
              <p className="max-w-[16rem] text-sm text-muted-foreground">
                {step.desc}
              </p>
            </li>
          ))}
        </ol>

        {/* Callout */}
        <div className="mx-auto mt-12 flex max-w-3xl flex-col items-center gap-4 rounded-2xl border border-primary/30 bg-primary/5 p-6 sm:flex-row sm:justify-between">
          <div className="flex items-start gap-3 text-sm leading-relaxed">
            <Wallet className="size-5 shrink-0 text-primary" />
            <p className="text-muted-foreground">
              به‌ازای هر خرید زیرمجموعه، درصد کمیسیون دریافت کنید و درخواست
              برداشت ثبت کنید.
            </p>
          </div>
          <Button
            className="w-full shrink-0 gap-2 sm:w-auto"
            onClick={() => pushView("register")}
          >
            ثبت‌نام کن و کد معرفت رو بگیر
            <ArrowLeft className="size-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
